import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import Dashboard from "../../components/Dashboard"
import { ENDPOINTS } from "../../constants"
import actionTypePrefixes from "../../state/actions/actionTypePrefixes"
import {
  performanceComparisonChartHasData,
  top5LdHasData,
  keyItemDataHasData,
  npsHasData,
  engagementAveragesHasData,
  nineBoxGridHasData,
  pulseChecksHasData,
  journeysHasData,
} from "../../utils/object-utils"
import {
  RiskOfLeaving,
  NineBoxGridSmall,
  EngagementScoreLineChart,
  EngagementScoreDoughnut,
  ChallengesFaced,
  EmployeeNetPromotorScoreDoughnut,
  PulseChecks,
  PerformanceComparison,
  Top5LD,
  DoingWell,
  NeedImproving,
  Journeys,
} from "../../components/widgets"

class PeopleBalanceSheetDashboard extends Component {
  static propTypes = {
    onReload: PropTypes.func.isRequired,
  }
  state = {
    // TODO: widget interraction state to go here, e.g. active nine box grid box
    // but beware you might need to pass this down to WidgetContainer in the renderData
    // prop to get `shouldComponentUpdate` to equate to true
  }
  render() {
    const { t, onReload } = this.props // eslint-disable-line react/prop-types
    const { isLoading, errorMessageKey, widgets, loadingFailed } = this.props.dashboard // eslint-disable-line
    const title = t("Dashboards.Names.PeopleBalanceSheet")
    const challengesFacedHasData =
      widgets.challengesFaced.data && widgets.challengesFaced.data.length > 0

    return (
      <Dashboard
        errorMessageKey={errorMessageKey}
        isLoading={isLoading}
        loadingFailed={loadingFailed}
        onReload={onReload}
        widgetData={widgets}
        title={title}
      >
        {engagementAveragesHasData(widgets.engagementScoreDoughnut.data) && (
          <EngagementScoreDoughnut
            data={widgets.engagementScoreDoughnut.data}
            appliedFilters={widgets.engagementScoreDoughnut.filters}
            exportEndpoint={ENDPOINTS.Export.EngagementAverageScore}
            subtitleKey={widgets.engagementScoreDoughnut.subtitle}
            sampleSize={widgets.engagementScoreDoughnut.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.engagementScoreLine.data) &&
          (widgets.engagementScoreLine.data.length > 1 && (
            <EngagementScoreLineChart
              data={widgets.engagementScoreLine.data}
              appliedFilters={widgets.engagementScoreLine.filters}
              exportEndpoint={ENDPOINTS.Export.EngagementCombinedAverages}
              subtitleKey={widgets.engagementScoreLine.subtitle}
              sampleSize={widgets.engagementScoreLine.sampleSize}
            />
          ))}

        {widgets.riskOfLeaving.data &&
          widgets.riskOfLeaving.data.length > 0 && (
            <RiskOfLeaving
              data={widgets.riskOfLeaving.data}
              appliedFilters={widgets.riskOfLeaving.filters}
              exportEndpoint={ENDPOINTS.Export.RiskOfLeavingPie}
              subtitleKey={widgets.riskOfLeaving.subtitle}
              sampleSize={widgets.riskOfLeaving.sampleSize}
            />
          )}

        {nineBoxGridHasData(widgets.nineBoxGridSummary.data) && (
          <NineBoxGridSmall
            summaryData={widgets.nineBoxGridSummary.data.reviews}
            drilldownData={widgets.nineBoxGridDrilldown.data}
            appliedFilters={widgets.nineBoxGridSummary.filters}
            exportEndpoint={ENDPOINTS.Export.SuccessionPlanning}
            dashboard={actionTypePrefixes.PeopleBalanceSheet}
            subtitleKey={widgets.nineBoxGridSummary.subtitle}
          />
        )}

        {npsHasData(widgets.employeeNetPromotorScore.data) && (
          <EmployeeNetPromotorScoreDoughnut
            data={widgets.employeeNetPromotorScore.data}
            appliedFilters={widgets.employeeNetPromotorScore.filters}
            exportEndpoint={ENDPOINTS.Export.NetPromoterScoreStats}
            subtitleKey={widgets.employeeNetPromotorScore.subtitle}
            sampleSize={widgets.employeeNetPromotorScore.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.doingWell.data) && (
          <DoingWell
            data={widgets.doingWell.data}
            appliedFilters={widgets.doingWell.filters}
            exportEndpoint={ENDPOINTS.Export.DoBest}
            subtitleKey={widgets.doingWell.subtitle}
            sampleSize={widgets.doingWell.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.needsImproving.data) && (
          <NeedImproving
            data={widgets.needsImproving.data}
            appliedFilters={widgets.needsImproving.filters}
            exportEndpoint={ENDPOINTS.Export.NeedsImproving}
            subtitleKey={widgets.needsImproving.subtitle}
            sampleSize={widgets.needsImproving.sampleSize}
          />
        )}

        {top5LdHasData(widgets.top5LD.data) && (
          <Top5LD
            data={widgets.top5LD.data}
            appliedFilters={widgets.top5LD.filters}
            exportEndpoint={ENDPOINTS.Export.LAndDStats}
            subtitleKey={widgets.top5LD.subtitle}
            sampleSize={widgets.top5LD.sampleSize}
          />
        )}

        {performanceComparisonChartHasData(widgets.performanceComparisonChart.data) && (
          <PerformanceComparison
            data={widgets.performanceComparisonChart.data}
            appliedFilters={widgets.performanceComparisonChart.filters}
            exportEndpoint={ENDPOINTS.Export.PerformanceComparisonChart}
            columns={2}
            dashboard={actionTypePrefixes.PeopleBalanceSheet}
            subtitleKey={widgets.performanceComparisonChart.subtitle}
            sampleSize={widgets.performanceComparisonChart.sampleSize}
          />
        )}

        {challengesFacedHasData && (
          <ChallengesFaced
            data={widgets.challengesFaced.data}
            appliedFilters={widgets.challengesFaced.filters}
            exportEndpoint={ENDPOINTS.Export.ChallengesFaced}
            subtitleKey={widgets.challengesFaced.subtitle}
          />
        )}

        {pulseChecksHasData(widgets.pulseCheckResponses.data) && (
          <PulseChecks
            data={widgets.pulseCheckResponses.data}
            appliedFilters={widgets.pulseCheckResponses.filters}
            exportEndpoint={ENDPOINTS.Export.PulseChecks}
          />
        )}

        {journeysHasData(widgets.journeyResponses.data) && (
          <Journeys
            data={widgets.journeyResponses.data}
            appliedFilters={widgets.journeyResponses.filters}
            exportEndpoint={ENDPOINTS.Export.Journeys}
          />
        )}
      </Dashboard>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.peopleBalanceSheet,
  }
}

export default compose(translate(), connect(mapStateToProps))(PeopleBalanceSheetDashboard)



// WEBPACK FOOTER //
// ./src/routes/dashboards/PeopleBalanceSheetDashboard.jsx